import { NgModule } from '@angular/core';
import { RouterModule} from '@angular/router';
import { routes } from './pages/routes';

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'ignore' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
